(function () {
  function updateArrows(swiper, prevBtn, nextBtn) {
    if (!prevBtn || !nextBtn) return;
    prevBtn.disabled = swiper.isBeginning;
    nextBtn.disabled = swiper.isEnd;
  }

  function initSection(section) {
    if (section.dataset.customerReviewV3Inited === 'true') return;

    const swiperEl = section.querySelector('[data-customer-review-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const prevBtn = section.querySelector('.customer-review-v3__arrow--prev');
    const nextBtn = section.querySelector('.customer-review-v3__arrow--next');
    const progressEl = section.querySelector('.customer-review-v3__progress');
    let progress = null;

    // A --review-slide-gap on the section widens the carousel for that page
    // alone; unset it stays 0, so every other page keeps the built-in spacing.
    const gapOffset = parseInt(getComputedStyle(section).getPropertyValue('--review-slide-gap'), 10) || 0;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 10 + gapOffset,
      speed: 400,
      watchOverflow: true,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      breakpoints: {
        0: {
          spaceBetween: 12 + gapOffset,
        },
        769: {
          spaceBetween: 10 + gapOffset,
        },
      },
      on: {
        init(s) {
          updateArrows(s, prevBtn, nextBtn);
        },
        slideChange(s) {
          progress?.sync();
          updateArrows(s, prevBtn, nextBtn);
        },
        reachBeginning(s) {
          updateArrows(s, prevBtn, nextBtn);
        },
        reachEnd(s) {
          progress?.sync();
          updateArrows(s, prevBtn, nextBtn);
        },
      },
    });

    progress =
      progressEl && window.CarouselProgress
        ? window.CarouselProgress.createSwiperProgress(swiper, progressEl)
        : null;

    section.dataset.customerReviewV3Inited = 'true';

    window.addEventListener('resize', () => {
      progress?.sync();
      updateArrows(swiper, prevBtn, nextBtn);
    });
  }

  function boot() {
    document.querySelectorAll('[data-customer-review-v3]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-customer-review-v3]').forEach(initSection);
  });
})();
